const PARTICULAS_NOMBRE = new Set(['de', 'del', 'la', 'las', 'los', 'y', 'e', 'da', 'do', 'das', 'dos', 'van', 'von']);

/**
 * Nombre propio para mostrar: "deisy gamba" -> "Deisy Gamba".
 * No modifica el valor guardado.
 */
export const formatPersonName = (name) => {
    const raw = String(name ?? '').trim().replace(/\s+/g, ' ');
    if (!raw) return '';
    return raw.split(' ').map((word, index) => {
        const lower = word.toLocaleLowerCase('es-CO');
        if (index > 0 && PARTICULAS_NOMBRE.has(lower)) return lower;
        return lower
            .split('-')
            .map((part) => (part ? part.charAt(0).toLocaleUpperCase('es-CO') + part.slice(1) : part))
            .join('-');
    }).join(' ');
};

/**
 * Primera letra mayúscula y el resto en minúscula.
 * Ej: "CONTADOR" -> "Contador", "Médico Familiar" -> "Médico familiar"
 */
export const toSentenceCase = (text) => {
    const raw = String(text ?? '').trim().replace(/\s+/g, ' ');
    if (!raw) return '';
    const lower = raw.toLocaleLowerCase('es-CO');
    return lower.charAt(0).toLocaleUpperCase('es-CO') + lower.slice(1);
};

/**
 * Convierte el código/nombre interno del servicio del doctor a etiqueta legible.
 * Ej: "328 psicologia" -> "Psicología"
 */
export const formatServiceName = (service) => {
    if (!service) return '';

    const normalizeService = (s) =>
        s
            .toLowerCase()
            .replace(/\d+/g, '')
            .replace(/_/g, ' ')
            .replace(/-/g, ' ')
            .trim();

    const normalized = normalizeService(service);

    const serviceMap = {
        'medicina familiar': 'Médico familiar',
        'medicina general': 'Médico general',
        'terapeuta respiratorio': 'Terapeuta respiratoria',
        'terapeuta respiratoria': 'Terapeuta respiratoria',
        'terapeuta ocupacional': 'Terapeuta ocupacional',
        'fonoaudiologia': 'Fonoaudiología',
        'fonoaudiología': 'Fonoaudiología',
        'psicologo': 'Psicología',
        'psicologia': 'Psicología',
        'psicología': 'Psicología',
        'nutricionista': 'Nutrición',
        'nutricion': 'Nutrición',
        'nutrición': 'Nutrición',
        'terapia fisica': 'Terapia física',
        'terapia física': 'Terapia física',
        'terapeuta fisico': 'Terapia física',
        'terapeuta físico': 'Terapia física',
        'fisioterapeuta': 'Fisioterapia',
        'trabajo social': 'Trabajo social',
        'enfermeria': 'Enfermería',
        'enfermería': 'Enfermería',
        'jefe enfermeria': 'Jefe de enfermería',
        'jefe enfermería': 'Jefe de enfermería',
        'auxiliar enfermeria': 'Auxiliar de enfermería',
        'auxiliar enfermería': 'Auxiliar de enfermería',
        'cuidador': 'Cuidador',
        'ingeniero sistemas': 'Ingeniero de sistemas',
        'abogado': 'Abogado',
        'contador': 'Contador',
        'auxiliar administrativo': 'Auxiliar administrativo',
    };

    if (serviceMap[normalized]) {
        return serviceMap[normalized];
    }

    for (const [key, value] of Object.entries(serviceMap)) {
        if (normalized.includes(key) || key.includes(normalized)) {
            return value;
        }
    }

    return toSentenceCase(
        service
            .replace(/\d+/g, '')
            .replace(/_/g, ' ')
            .replace(/-/g, ' ')
    );
};
